import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import pageContext from '@bingads-webui-static-legacy/page-context';
import popup from '@bingads-webui-component-legacy/dialog/popup';
import { exclusionsUpdate } from '../model/bulk-campaign-exclusions';
import withUiBlock from '@bingads-webui-component-legacy/uiblocker/index';
import ViewModel from '../viewmodel/bulk-campaign-exclusions';
import template from '../template/bulk-campaign-exclusions.pug';
import instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import BulkEditAdScheduleTimeZoneView from '@bingads-webui-campaign-legacy/campaign-bulk-edit/view/bulkEditAdScheduleTimeZone';
import BulkEditAdScheduleTimeZoneModel from '@bingads-webui-campaign-legacy/campaign-bulk-edit/model/bulkEditAdScheduleTimeZone';
import { CampaignsDatePicker } from '@bingads-webui-campaign/campaigns-date-picker';

const i18nGlobal = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');
let dynamicPermissions = _.result(pageContext.Permissions, 'dynamic', {});
const isCampaignLifetimeBudgetEnabled = dynamicPermissions.CampaignLifetimeBudget && !dynamicPermissions.MaeLifetimeBudgetExclusion;

let currentAlertId = null;

function dismissAlert() {
  if (currentAlertId) {
    window.App.views.alertCenter.dismiss(currentAlertId);
    currentAlertId = null;
  }
}

function showAlert(message) {
  dismissAlert();

  currentAlertId = window.App.views.alertCenter.show({
    message,
    level: 'Error',
    dismissible: true,
  }, currentAlertId);
}

function showUnknownError() {
  const unexpectedError = i18nGlobal.getString('ErrorNumber_-1');

  showAlert(unexpectedError);
}

export default class View extends Backbone.View {
  initialize({ gridView, inlineError, isForVNext, grid, campaignType, cacheManager }) {
    this.gridView = gridView;
    this.inlineError = inlineError;
    this.cacheManager = cacheManager;
    this.viewModel = new ViewModel({ isForVNext, campaignType, campaignLifetimeBudget: isCampaignLifetimeBudgetEnabled });

    const senario = instrumentation.bulkEditCampaignExclusions.create();

    this.activity = senario.bulkEditCampaignExclusions.create();
    this.activity.start();

    this.endDatePicker = new CampaignsDatePicker({
      allowNoDate: true,
      noDateLabel: i18nGlobal.getString('noEndDate'),
      dateLabel: i18nGlobal.getString('EndBy'),
      noDateGroupAriaLabel: i18nGlobal.getString('Audience_Campaign_BulkEdit_EndDate'),
      datePickerAriaLabel: i18nGlobal.getString('Audience_Campaign_BulkEdit_EndDate'),
    });

    this.endDatePicker.on('dateChanged', () => {
      this.viewModel.errorMsg('');
    });

    this.adScheduleTimeZoneView = new BulkEditAdScheduleTimeZoneView(_.defaults({
      model: new BulkEditAdScheduleTimeZoneModel({ entity: 'Campaign' }),
      onOperationSuccess: () => {
        this.trigger('hide');
      },
    }, {
      grid,
      isForVNext,
    }));
  }

  get events() {
    return {
      'click .btn-primary': 'save',
      'click .btn-default': 'cancel',
      'click .nodate': () => this.viewModel.errorMsg(''),
    };
  }

  render() {
    this.$el.html(template(this.viewModel));
    ko.applyBindings(this.viewModel, this.el);

    if (this.adScheduleTimeZoneView) {
      this.$('.schedule-timezone-setting-container').append(this.adScheduleTimeZoneView.render().el);
    }

    if (isCampaignLifetimeBudgetEnabled && this.endDatePicker) {
      this.$('[data-ref="childView"]').append(this.endDatePicker.render().el);
    }
    return this;
  }

  save() {
    if (!this.viewModel.validate(this.endDatePicker)) {
      return;
    }

    if (!popup.confirm(this.viewModel.getConfirmText())) {
      return;
    }

    dismissAlert();

    if (this.viewModel.getSelection().name === 'AdScheduleUseSearcherTimeZone' &&
      this.adScheduleTimeZoneView) {
      this.adScheduleTimeZoneView.submitJob();
      return;
    }

    const selectedIds = this.gridView.selectedKeys() || [];
    const idData = _.reduce(selectedIds, (memo, id, index) => {
      memo[`CampaignsGrid.SelectedIds[${index}]`] = id;
      return memo;
    }, {});
    const exclusionData = this.viewModel.getResult(this.endDatePicker);
    const formData = _.extend({}, idData, exclusionData);

    exclusionsUpdate(formData)
      .finally(withUiBlock(this.gridView.$el))
      .then((res) => {
        if (res && _.isArray(res.Errors) && res.Errors[0] && res.Errors[0].Message) {
          this.viewModel.errorMsg(res.Errors[0].Message);
          showAlert(res.Errors[0].Message);
        } else if (res && res.Records && res.Records.Rows) {
          const errors = _.chain(res.Records.Rows)
            .map((row) => {
              return _.isArray(row.Errors) && row.Errors.length > 0 && row.Errors[0].Message && row.Errors[0].Message.length > 0 ?
                [row.Id, [row.Errors[0].Message[0]]] :
                null;
            })
            .compact()
            .object()
            .value();

          if (_.isEmpty(errors)) {
            this.inlineError.clearErrors();
            this.gridView.deselectAll();

            const selection = _.find(this.viewModel.selections, (s) => s.value === this.viewModel.selectedValue()[0]);

            if (selection?.shouldGridReload) {
              this.cacheManager.invalidate('Campaign');
              this.gridView.refresh(true);
            }
          } else {
            this.inlineError.setErrors(errors);

            this.gridView.once('willReload', () => {
              this.inlineError.clearErrors();
            });
          }

          this.trigger('hide');
        } else {
          showUnknownError();
        }
        this.activity.stop();
      })
      .catch(() => {
        showUnknownError();
      });
  }

  cancel() {
    this.trigger('hide');
  }
}
